import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHttp, useNotification } from 'src/hooks';

const DiscordCallback: React.FC = () => {
    const navigate = useNavigate();
    const { sendRequest, error } = useHttp();
    const notify = useNotification();
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    const fetchDiscordUser = () => {
        const jwtString = localStorage.getItem('jwt');
        let token = '';
        if (jwtString) {
            const data = JSON.parse(jwtString);
            token = data.token;
        }

        sendRequest(
            {
                url: `discord/callback?code=${code}&state=${state}`,
                accessToken: token,
                method: 'GET',
            },
            () => {
                navigate(`/profile`);
            },
        );
    };

    useEffect(() => {
        fetchDiscordUser();
    }, []);

    useEffect(() => {
        if (error) {
            notify(`${error}`, 'error');
            navigate('/');
        }
    }, [error]);

    return (
        <div>
            <div className="text-white text-center">Redirecting you back to the platform...</div>
        </div>
    );
};

export default DiscordCallback;
